import React, { useState } from 'react';
import { FaImage } from 'react-icons/fa';
import { ExpandHeader, ToolCallWrapper } from '../shared/ToolCallComponents';

interface ImageToolProps {
    item: any;
    isInProgress: boolean;
}

export const GenerateImages: React.FC<ImageToolProps> = ({ item, isInProgress }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <ToolCallWrapper>
            <ExpandHeader
                icon={<FaImage className="mr-2 text-neutral-500 dark:text-neutral-400" size={14}/>}
                title="Generating images"
                isExpanded={isExpanded}
                isInProgress={isInProgress}
                onClick={() => setIsExpanded(prev => !prev)}
            />
            {isExpanded && item.args && Array.isArray(item.args.prompts) && (
                <ul className="list-none pl-6 space-y-1">
                    {item.args.prompts.map((promptObj: { prompt: string }, index: number) => (
                        <li key={index} className="flex items-start">
                            <span className="text-neutral-500 dark:text-neutral-400 mr-2">•</span>
                            <span>{promptObj.prompt ?? ''}</span>
                        </li>
                    ))}
                </ul>
            )}
        </ToolCallWrapper>
    );
};
